module.exports = "<div class=\"alert {{ $ctrl.messageService.alerttype }}\" ng-show=\"$ctrl.messageService.show\">\n    <icon class=\"alert__icon alert__icon--success\" ng-if=\"$ctrl.messageService.alerttype === 'alert--success'\" icon=\"tick\"></icon>\n    <icon class=\"alert__icon alert__icon--failure\" ng-if=\"$ctrl.messageService.alerttype === 'alert--fail'\" icon=\"cross\"></icon>\n    <p class=\"alert__message\" ng-repeat=\"message in $ctrl.messageService.messages\">{{message}}</p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/page/views/message.html
// module id = 728
// module chunks = 0